meedy.controller('meedy.accountChangePasswordController', ['$scope', '$state', '$timeout', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.passwordModel',
    function ($scope, $state, $timeout, objectHelper, applicationModel, userModel, passwordModel) {

        function setData() {
            $scope.passwordData = new LoginMeedyVO();

            $scope.authenticationError = false;

            $scope.forms = {
                passwordForm: null
            };

            $scope.passwordIsToWeak = false;
            $scope.differentPasswords = false;
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$on(Event.MEEDY.PASSWORD.CHANGE_PASSWORD.SUCCESS, function (event, error) {
                $state.go(Constant.STATE.APP.MEEDY.CALENDAR.INDEX);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {


            $scope.onChange = function() {
                if($scope.forms.passwordForm && $scope.passwordData.newPassword && $scope.passwordData.password
                    && ($scope.passwordData.newPassword.length > 7 && $scope.passwordData.password.length > 7
                    && $scope.passwordData.newPassword === $scope.passwordData.password)) {

                    var power = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g;

                    var _lowerLetters = /[a-z]+/.test($scope.passwordData.password);
                    var _upperLetters = /[A-Z]+/.test($scope.passwordData.password);
                    var _numbers = /[0-9]+/.test($scope.passwordData.password);
                    var _symbols = _regex.test($scope.passwordData.password);

                    if(_lowerLetters) {
                        power++;
                    }if(_upperLetters) {
                        power++;
                    }if(_numbers) {
                        power++;
                    }if(_symbols) {
                        power++;
                    }

                    if(power < 3) {
                        $scope.passwordIsToWeak = true;
                    } else {
                        $scope.passwordIsToWeak = false;
                    }
                    $scope.differentPasswords = false;
                } else if($scope.passwordData.newPassword !== $scope.passwordData.password) {
                    $scope.differentPasswords = true;
                }
            };

            $scope.changePassword = function() {
                $scope.forms.passwordForm.$setSubmitted();

                var power = 0;
                var _regex = /[$-/:-?{-~!"^_`\[\]]/g;

                var _lowerLetters = /[a-z]+/.test($scope.passwordData.password);
                var _upperLetters = /[A-Z]+/.test($scope.passwordData.password);
                var _numbers = /[0-9]+/.test($scope.passwordData.password);
                var _symbols = _regex.test($scope.passwordData.password);

                if(_lowerLetters) {
                    power++;
                }if(_upperLetters) {
                    power++;
                }if(_numbers) {
                    power++;
                }if(_symbols) {
                    power++;
                }

                if(power < 3) {
                    $scope.passwordIsToWeak = true;
                    return;
                } else {
                    $scope.passwordIsToWeak = false;
                }

                if ($scope.forms.passwordForm.$valid) {
                    passwordModel.changePassword($scope.passwordData.oldPassword, $scope.passwordData.newPassword);
                }
            };

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.USER.CHANGE_PASSWORD);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.CHANGE_PASSWORD');
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
